import { render } from "./ChildParentalConsent.vue?vue&type=template&id=2feb8d08&scoped=true"
import script from "./ChildParentalConsent.vue?vue&type=script&lang=js"
export * from "./ChildParentalConsent.vue?vue&type=script&lang=js"

import "./ChildParentalConsent.vue?vue&type=style&index=0&id=2feb8d08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2feb8d08"]])

export default __exports__